import { Button } from '@llt-frontend/react-material-button';
import { InteractionEventTrigger } from '@blueshift-ui/telemetry';
import { Link } from 'react-router-dom';
import NotificationCard from '../messaging/notification-card';
import React from 'react';

//

function ActivityNotification({ analytics, actionText, children, url }) {
  return (
    <NotificationCard
      action={
        <InteractionEventTrigger
          analytics={analytics}
          element={Button}
          elementProps={{
            component: Link,
            contained: true,
            to: url,
          }}
        >
          {actionText}
        </InteractionEventTrigger>
      }
    >
      {children}
    </NotificationCard>
  );
}

// Exports
// -------

export default ActivityNotification;
